import helperModule from '../helper.module';

class CollectionHelper {
    any(collections) {
        if (collections == undefined) {
            return undefined;
        }

        const zero = 0;
        return collections.length > zero;
    }

    first(collections) {
        if (collections == undefined) {
            return undefined;
        }

        if (!this.any(collections)) {
            return undefined;
        }

        const firstIndex = 0;
        return collections[firstIndex];
    }
}

export default helperModule.service('collectionHelper', CollectionHelper);



// WEBPACK FOOTER //
// ./modules/helper/collectionHelper/collectionHelper.service.js